/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const FileTreeFileItemParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('file')],
    ['name', codecString],
    ['id', codecNumber],
]);
export class FileTreeFileItem extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FileTreeFileItemParser.decode(input).map(res => new FileTreeFileItem(res));
    }
    static unsafeDecode(input) {
        return FileTreeFileItem.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FileTreeFileItemParser.encode(data);
    }
    static schema() {
        return FileTreeFileItemParser.schema();
    }
}
